// extracted by mini-css-extract-plugin
module.exports = {"Inquery":"Inquery-module--Inquery--HYknD","InqueryFinance":"Inquery-module--InqueryFinance--1qqyH Inquery-module--Inquery--HYknD"};